module.exports = __webpack_public_path__ + "img/step_three_brand_en.6be8450b.png";